let firebase = require('firebase');

const config = {
    apiKey: "AIzaSyCWZe1vS6h0wKoUP8MgmrnkMHdt-yCqAuw",
    authDomain: "arqperformance-c2ef7.firebaseapp.com",
    databaseURL: "https://arqperformance-c2ef7.firebaseio.com",
    projectId: "arqperformance-c2ef7",
    storageBucket: "arqperformance-c2ef7.appspot.com",
    messagingSenderId: "479291756311",
    appId: "1:479291756311:web:681cffd9409cc2a9663152",
    measurementId: "G-5HDNZ4CXY8"
}

firebase.initializeApp(config);

const email = 'bladonmore@arq.com';
const password = 'bladonmore';

firebase.auth().signInWithEmailAndPassword(email, password).catch(function (error) {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  // ...
});


export const database = firebase.database();
const databaseRef = firebase.database().ref();

export const usersRef = databaseRef.child("users");
export const activitiesRef = databaseRef.child("activities");
